// hooks/user/useHomepageData.js
import { useEffect, useState } from "react";
import HomepageUserService from "../../services/user/HomepageUserService";

export default function useHomepageData() {
  const [data, setData] = useState({
    categories: [],
    popularItems: [],
    gallery: [],
    insights: [],
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function fetchHomepage() {
      try {
        setLoading(true);
        const res = await HomepageUserService.getHomepageData();

        if (!isMounted) return;

        setData({
          categories: res.data.categories || [],
          popularItems: res.data.popularItems || [],
          gallery: res.data.gallery || [],
          insights: res.data.insights || [],
        });
      } catch (err) {
        if (isMounted) setError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchHomepage();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    categories: data.categories,
    popularItems: data.popularItems,
    gallery: data.gallery,
    insights: data.insights,
    loading,
    error,
  };
}
